module.exports = __webpack_public_path__ + "assets/img/data-null.64121001.png";